/**
 * Supported Azure locations for the dashboard's connect + scope UI. Mirrors
 * services/shared/azure-locations.ts (kept in sync manually — the dashboard
 * cannot import from the backend workspace).
 */

export interface AzureLocationOption {
  code:  string;
  label: string;
}

export const SUPPORTED_AZURE_LOCATIONS: AzureLocationOption[] = [
  { code: 'eastus',              label: 'East US' },
  { code: 'eastus2',             label: 'East US 2' },
  { code: 'centralus',           label: 'Central US' },
  { code: 'westus2',             label: 'West US 2' },
  { code: 'westus3',             label: 'West US 3' },
  { code: 'canadacentral',       label: 'Canada Central' },
  { code: 'northeurope',         label: 'North Europe' },
  { code: 'westeurope',          label: 'West Europe' },
  { code: 'uksouth',             label: 'UK South' },
  { code: 'francecentral',       label: 'France Central' },
  { code: 'germanywestcentral',  label: 'Germany West Central' },
  { code: 'switzerlandnorth',    label: 'Switzerland North' },
  { code: 'swedencentral',       label: 'Sweden Central' },
  { code: 'centralindia',        label: 'Central India' },
  { code: 'southeastasia',       label: 'Southeast Asia' },
  { code: 'eastasia',            label: 'East Asia' },
  { code: 'japaneast',           label: 'Japan East' },
  { code: 'australiaeast',       label: 'Australia East' },
  { code: 'brazilsouth',         label: 'Brazil South' },
];

export function locationLabel(code: string): string {
  return SUPPORTED_AZURE_LOCATIONS.find(l => l.code === code)?.label ?? code;
}
